// Clickable non-button elements are marked role="button" and tabIndex=0;
// this makes Enter and Space trigger their click like a real button.
export const handleKeyboardActivation = (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;
  const target = event.target;
  if (!target || target.getAttribute("role") !== "button") return;
  if (["BUTTON", "A", "INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)) return;
  event.preventDefault();
  target.click();
};

export const installKeyboardActivation = () => {
  document.addEventListener("keydown", handleKeyboardActivation);
  return () => document.removeEventListener("keydown", handleKeyboardActivation);
};
